import fetchAPI from '../fetchAPI';

interface CallGenerateBillArtifactProps {
  id: string;
  kind: 'invoice' | 'report';
}

interface GenerateBillArtifactResult {
  id: string;
  kind: 'invoice' | 'report';
  fileName: string;
  shareUrl: string | null;
}

export const callGenerateBillArtifact = async ({
  id,
  kind
}: CallGenerateBillArtifactProps): Promise<iResponse<GenerateBillArtifactResult>> => {
  const response: iResponse<GenerateBillArtifactResult> = await fetchAPI({
    method: `POST`,
    route: `bills/${id}/generate-artifact`,
    data: { kind }
  });
  return response;
};

export default callGenerateBillArtifact;
